import {getUserDetailsById} from "api/dashboard.api";
import moment from "moment";
import {useEffect, useState} from "react";
import styled from "styled-components";
import {StarReview} from "ui/base/starReview/StarReview";
import {UserIcon} from "ui/icons";
import {defaultThemeColors, fonts} from "ui/theme";
import {getAvatarUrl} from "utils";

export const ReviewCard = ({reviewData}) => {
    const [user, setUser] = useState(null)

    useEffect(() => {
        if (reviewData.user_id) {
            getUserProfileById(reviewData.user_id)
        }
    }, [reviewData.user_id])

    const getUserProfileById = (user_id) => {
        getUserDetailsById(user_id)
            .then(res => {
                if (res) {
                    setUser(res)
                }
            })
            .catch(err => {
                console.log('err: ', err)
            })
    }

    return (
        <SliderCard>
            <Row>
                <ProfileBlock>
                    <Avatar>
                        {user?.profile_pic ? (
                            <img
                                src={getAvatarUrl(user?.profile_pic)}
                                alt={user?.first_name}
                            />
                        ) : (
                            <UserIcon color="txt"/>
                        )}
                    </Avatar>
                    <PersonalInfo>

                        <Name>{user?.first_name ? user?.first_name : "unknown"} {user?.last_name}</Name>
                        <CreatedDate>{moment(reviewData.updated_at).format("MMM DD, YYYY")}</CreatedDate>
                    </PersonalInfo>
                </ProfileBlock>
                <Rating>
                    {/* <ReactStars count={5} size={24} activeColor="#FF827A" edit={false} value={reviewData.rating} /> */}
                    <StarReview rate={reviewData.rating} size={18}/>
                </Rating>
            </Row>
            <ReviewContent>
                {reviewData.review}
            </ReviewContent>
        </SliderCard>
    )
}

const SliderCard = styled.div`
    position: relative;
    border: solid 2px #EDF0FF;
    border-radius: 8px;
    padding: 30px;
    width: 100%;
    height: 100%;

    @media (max-width: 1024px) {
        padding: 12px;
    }
`;

const Row = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

const ProfileBlock = styled.div`
    display: flex;
    align-items: center;
`;

const Avatar = styled.div`
    width: 70px;
    height: 70px;
    background-color: ${defaultThemeColors.inputBgNeutral};
    border-radius: 70px;
    object-fit: cover;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;

    & > svg {
        height: 30px;
        width: 30px;

        @media (max-width: 1024px) {
            width: 20px;
            height: 20px;
        }
        opacity: 0.5;
    }

    & > img {
        height: 100%;
        width: 100%;
        object-fit: cover;
    }

    @media (max-width: 1024px) {
        width: 36px;
        height: 36px;
    }
`;

const PersonalInfo = styled.div`
    display: flex;
    flex-direction: column;
    margin-left: 20px;
`;

const Name = styled.h4`
    font-size: ${fonts.sizes.big};
    font-weight: bold;
    text-align: center;

    @media (max-width: 1024px) {
        text-align: left;
        font-size: ${fonts.sizes.medium};
    }
`;

const CreatedDate = styled.div`
    font-size: ${fonts.sizes.small};
    font-weight: 600;
    color: #191D3A;

    @media (max-width: 1024px) {
        font-size: ${fonts.sizes.extraSmall};
    }
`;

const Rating = styled.div`
    display: flex;
    align-items: center;
`;

const ReviewContent = styled.div`
    font-size: ${fonts.sizes.medium};
    color: #191D3A;
    margin-top: 20px;
`;